<template>
  <div class="content">
    <div class="images">
      <video style="width: 520rem; height: 440rem" controls>
        <source
          src="http://hoowetech.com:9000/uploads/20230605/1b9614366afdbe2f7c6b8cdd015d328b.mp4"
          type="video/mp4"
        />
      </video>
      <video style="width: 520rem; height: 440rem" controls>
        <source
          src="http://hoowetech.com:9000/uploads/20230605/3541bf139d92849a6f2429cd247b32d3.mp4"
          type="video/mp4"
        />
      </video>
    </div>
    <div class="display">
      <div class="display-title">设备展示</div>
      <div class="display-tips">Equipment display</div>
      <div class="display-items">
        <div class="item" v-for="(item, index) in deviceList" :key="index">
          <img :src="item.image" alt="" />
          <div class="text-div">
            <div v-for="(tag, key) in item.tags" :key="key">{{ tag }}</div>
          </div>
        </div>
      </div>
    </div>
    <img
      class="jgnl-img"
      src="http://hoowetech.com:9000/uploads/20230605/19d43fe8aaeaaf94e52484a42ea88c0f.png"
      alt=""
    />
    <div class="display">
      <div class="display-title">产品展示</div>
      <div class="display-tips">Product display</div>
      <div class="display-items">
        <div class="item" v-for="(item, index) in projectList" :key="index">
          <img :src="item.image" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deviceList: [],
      deviceIndex: 0,
      projectList: [],
      productIndex: 0,
    };
  },
  mounted() {
    this.getDeviceList();
    this.getProjectList();
  },
  methods: {
    getDeviceList() {
      this.$api.device.list().then((res) => {
        this.deviceList = res;
      });
    },
    getProjectList() {
      this.$api.project.list().then((res) => {
        this.projectList = res;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  .images {
    display: flex;
    justify-content: space-between;
    padding: 44rem 300rem;
    background: #f7fbff;

    img {
      width: 337rem;
      height: 280rem;
    }
  }

  .display {
    padding: 201rem 300rem;
    background: #edf5fa;

    .display-title {
      font-weight: 500;
      font-size: 36px;
      line-height: 44px;
      color: #000000;
    }

    .display-tips {
      font-weight: 500;
      font-size: 20rem;
      line-height: 44rem;
      text-transform: uppercase;
      color: rgba(0, 0, 0, 0.26);
    }

    .display-items {
      display: flex;
      justify-content: space-between;
      margin-top: 67rem;

      .item {
        padding: 20rem 10rem;
        text-align: center;
        font-weight: 400;
        font-size: 14rem;
        line-height: 21px;
        text-align: center;
        color: rgba(0, 0, 0, 0.9);
        // cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .text-div {
          margin-top: 44rem;
        }

        img {
          width: 250rem;
          height: 200rem;
        }
      }

      .checked {
        background: #83c5ff;
        box-shadow: 0px 4px 10px rgba(44, 107, 164, 0.4);
      }
    }
  }

  .jgnl-img {
    width: 100%;
  }
}
</style>